import React from 'react';
import { connect } from 'react-redux';

import ResponsesManager from '../../../Shared/components/responses/responsesManager';
import * as filterActions from '../../actions/filters';
import massEdit from '../../actions/massEdit';
import questionActions from '../../actions/questions';
import { deleteResponse, getGradedResponsesWithCallback, submitResponseEdit } from '../../actions/responses';
import C from '../../constants';
import { rematchAll, rematchOne } from '../../libs/grading/rematching.ts';

function DiagnosticResponsesManager(props) {
  return (
    <ResponsesManager
      {...props}
      Constants={C}
      deleteResponse={deleteResponse}
      filterActions={filterActions}
      getGradedResponsesWithCallback={getGradedResponsesWithCallback}
      massEditActions={massEdit}
      questionActions={questionActions}
      rematchAll={rematchAll}
      rematchOne={rematchOne}
      storeResponsesLocally={true}
      submitResponseEdit={submitResponseEdit}
    />
  );
}

function select(state) {
  return {
    conceptsFeedback: state.conceptsFeedback,
    concepts: state.concepts,
    filters: state.filters,
    massEdit: state.massEdit,
  };
}

export default connect(select)(DiagnosticResponsesManager);
